import { render, staticRenderFns } from "./MultipleSelectWidget.vue?vue&type=template&id=212da923&lang=pug&"
import script from "./MultipleSelectWidget.vue?vue&type=script&lang=js&"
export * from "./MultipleSelectWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports